<script setup lang="ts">
import { useShortsFeedStore } from '~/store/shortsFeedStore';
import { useVideoHistoryStore } from '~/store/videoHistoryStore';
import { storeToRefs } from 'pinia';

import { GlassButton } from '~/components/GlassButton';

import IconMaterialSymbolsSlowMotionVideo from '~icons/material-symbols/slow-motion-video-sharp';

const emit = defineEmits<{
	(e: 'open-feed'): void;
}>();

const feedStore = useShortsFeedStore();
const historyStore = useVideoHistoryStore();
const { videos, isPreloaded, allWatched } = storeToRefs(feedStore);
const { historyItems, isHistoryLoaded } = storeToRefs(historyStore);

const firstVideo = computed(() => {
	const feedVideo = videos.value[0];
	if (feedVideo) return feedVideo;

	const historyVideo = historyItems.value?.[0];
	if (historyVideo) {
		return {
			property: historyVideo.property,
			videoUrl: historyVideo.videoUrl,
			thumbnailUrl: historyVideo.thumbnailUrl
		};
	}
	return null;
});

const hasVideo = computed(
	() =>
		!isPreloaded.value ||
		!isHistoryLoaded.value ||
		!!firstVideo.value ||
		allWatched.value
);

function handleClick() {
	emit('open-feed');
}
</script>

<template>
	<GlassButton
		v-if="hasVideo"
		size="auto"
		class="size-10 rounded-full lg:size-auto lg:rounded-[2px] lg:gap-2 lg:px-3 lg:py-2"
		aria-label="Ver vídeos em destaque"
		@click="handleClick"
	>
		<IconMaterialSymbolsSlowMotionVideo class="size-5 text-white" />
		<span class="hidden text-sm font-medium text-white lg:inline">Shorts</span>
	</GlassButton>
</template>
